import { z } from "zod";
export const publishedRuleKindSchema = z.enum(["FISCAL", "OPERATIONAL_COST", "COMMERCIAL_FEE"]);
export const publishedRuleMatchCategorySchema = z.enum(["EXACT", "SAME_APPLICABILITY"]);
const digestSchema = z.string().regex(/^sha256:[a-f0-9]{64}$/);
export const publishedRulesetReferenceSchema = z
    .object({
    id: z.string().uuid(),
    version: z.string().trim().min(1).max(80),
    contentDigest: digestSchema,
})
    .strict();
export const publishedRuleMatchSchema = z
    .object({
    ruleId: z.string().uuid(),
    kind: publishedRuleKindSchema,
    category: publishedRuleMatchCategorySchema,
})
    .strict();
export const publishedRuleMatchingSchema = z
    .object({
    schemaVersion: z.literal("1.0.0"),
    proposalId: z.string().uuid(),
    availability: z.enum(["AVAILABLE", "NO_PUBLISHED_BASE"]),
    publishedRuleset: publishedRulesetReferenceSchema.nullable(),
    proposed: z
        .object({
        kind: publishedRuleKindSchema,
        exactFingerprint: digestSchema,
        applicabilityFingerprint: digestSchema,
    })
        .strict(),
    matches: z.array(publishedRuleMatchSchema).max(50),
    checkedRuleCount: z.number().int().nonnegative(),
    truncated: z.boolean(),
})
    .strict();
//# sourceMappingURL=published-rule-matching.js.map